import Overlay from 'Components/Overlay';
import React from 'react';
import Input from 'Components/Input';
import Cx from 'classnames';
import { ReactComponent as Esclamation } from 'Icons/esclamation.svg';

const ConfirmationPopup = (props) => ( 
    <Overlay>
        <div className="bg-light-blue box-shadow ph-20 pv-20 br-5 tCenter">
            <Esclamation className={'wt-40 ht-40'}/>
            <div className="mb-10 tCenter fSemibold fs-20 mt-10 mb-10">
                {props.text || ''} 
            </div>
            <div className="col-1 ht-60 flex flex-middle flex-center">
                <button className="ht-40 br-5 theme-color border-theme fs-18 fBold wt-150 mr-30" onClick={props.onCancel}>No</button>
                <button className={"ht-40 br-5 white-color bg-theme fs-18 fBold wt-150"} onClick={props.onSave}>Yes</button>
            </div>
        </div>
    </Overlay>
);

export default ConfirmationPopup;